const formatDate = (value) => {
  return value.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const isDate = (value) => {
  let result = false;

  if (value) {
    if (value !== "0001-01-01T00:00:00") {
      var date = new Date(value);
      result = date instanceof Date && !isNaN(date.valueOf());
    }
  }

  return result;
};

const formatDecimal = (
  value,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
) => {
  return Number(value).toLocaleString("de-UY", {
    style: "decimal",
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

module.exports = {
  formatDate,
  formatDecimal,
  isDate,
};
